import applicationSurvey from "./applicationSurvey";
import organicIntegrity from "./organicIntegrity";
import answeredSurvey from "./answeredSurvey";
import simpleSurvey from "./simpleSurvey";

const questionnaireService = [{
    matcher: /questionnaire\/(.*)/,
    reply: config => {
        const id = /questionnaire\/(.*)/.exec(config.url)[1];
        let questionnaire;
        if(id === 'applicationSurvey') {
           questionnaire =  applicationSurvey;
        } else if(id === 'organicIntegrity') {
            questionnaire =  organicIntegrity;
        } else if(id === 'answeredSurvey') {
            questionnaire =  answeredSurvey;
        } else if(id === 'simpleSurvey') {
            questionnaire = simpleSurvey;
        } else {
            questionnaire =  applicationSurvey;
        }
        return [200, questionnaire];
    }
}]

export default questionnaireService;